import api from "@/modules/shared/api/axios";

export const fetchIndustries = async (params = {}) => {
  const resp = await api.get("/references/industries", {
    params,
  });
  return resp?.data?.data || [];
};

export const fetchProvinces = async (params = {}) => {
  const resp = await api.get("/references/provinces", {
    params,
  });
  return resp?.data?.data || [];
};

export const lookupCompanyByUnified = async (unifiedNumber) => {
  if (!unifiedNumber) return [];
  const resp = await api.get(`/references/company/${unifiedNumber}`);
  const payload = resp?.data?.data;
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload ? [payload] : [];
};

export const fetchFieldOfWorkTree = async (params = {}) => {
  const resp = await api.get("/field-of-work-tree", { params });
  return resp?.data?.data || [];
};
